export const LOCAL_STORAGE_KEY = "ocplcSelectedRowData";
export const SELECTED_ROW = "lastSelectedRow";

// Save to localStorage
export const saveToLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

// Get from localStorage
export const getFromLocalStorage = (key) => {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
};

// Clear (empty) the value of a key in localStorage
export const clearLocalStorageKey = (key) => {
    localStorage.setItem(key, JSON.stringify({})); 
};
